import {gql} from "@apollo/client";
import {client} from "graphql/client";

export const GET_ACCOUNT_TMS_DISPATCHER_BY_ACCOUNT_ID = gql`
    query GetAccountTmsDispatcherByAccountId($accountId: Long!) {
        getAccountTmsDispatcherByAccountId(accountId: $accountId) {
            id
            accountId
            warehouseId
        }
    }
`;

export interface AccountTmsDispatcherType {
    id: number;
    accountId: number;
    warehouseId: number;
}

export interface GetAccountTmsDispatcherByAccountIdQueryVariables {
    accountId: number;
}

export interface GetAccountTmsDispatcherByAccountIdQuery {
    getAccountTmsDispatcherByAccountId: AccountTmsDispatcherType;
}

export const getAccountTmsDispatcherByAccountId = async (accountId: number): Promise<AccountTmsDispatcherType> => {
    const {data} = await client.query<GetAccountTmsDispatcherByAccountIdQuery, GetAccountTmsDispatcherByAccountIdQueryVariables>({
        query: GET_ACCOUNT_TMS_DISPATCHER_BY_ACCOUNT_ID,
        variables: {accountId}
    });
    return data.getAccountTmsDispatcherByAccountId;
}; 